<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Login v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <img src="../assets/images/logo/logo.png" alt="logo" width="75" />
          <img
            src="../assets/images/logo/logop2.png"
            class="mt-2 ml-1"
            alt="logo"
            height="35"
          />
        </b-link>

        <b-card-title class="mb-1"
          >Bem-vindo ao sistema de Checklist!
        </b-card-title>
        <b-card-text class="mb-2">
          Por favor, forneca suas credenciais para acessar a plataforma.
        </b-card-text>

        <!-- form -->
        <validation-observer ref="loginForm" #default="{ invalid }">
          <b-form class="auth-login-form mt-2" @submit.prevent>
            <!-- email -->
            <b-form-group label-for="email" :label="cpfMode ? 'CPF' : 'Login'">
              <validation-provider
                #default="{ errors }"
                name="Login"
                rules="required"
              >
                <b-form-input
                  id="login"
                  v-model="email"
                  name="login-email"
                  :type="cpfMode ? 'tel' : 'text'"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="cpfMode ? '000.000.000-00' : 'john.doe'"
                  :maxlength="cpfMode ? 14 : undefined"
                  autofocus
                />
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="password">Senha</label>
                <b-link :to="{ name: 'auth-forgot-password-v1' }">
                  <small>Esqueceu sua senha?</small>
                </b-link>
              </div>
              <validation-provider
                #default="{ errors }"
                name="Password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="login-password"
                    placeholder="Password"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- checkbox -->
            <b-form-group>
              <b-form-checkbox
                id="remember-me"
                v-model="status"
                name="checkbox-1"
              >
                Lembre dos meus dados
              </b-form-checkbox>
            </b-form-group>

            <!-- submit button -->
            <b-button
              variant="primary"
              type="submit"
              block
              :disabled="invalid"
              @click="login"
            >
              Entrar
            </b-button>

            <b-button
              v-if="!cpfMode"
              variant="outline-primary"
              block
              class="mt-1"
              @click="switchToCpfMode"
            >
              Entrar com CPF
            </b-button>

            <div v-if="cpfMode" class="text-center mt-1">
              <b-link @click="switchToNormalMode">
                <small>Entrar com usuário</small>
              </b-link>
            </div>
          </b-form>
        </validation-observer>
      </b-card>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
} from "bootstrap-vue";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userEmail: "",
      password: "",
      status: "",
      cpfMode: false,
      // validation rules
      required,
      email,
      passwordFieldType: "password",
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  watch: {
    email(newVal) {
      if (this.cpfMode && typeof newVal === "string") {
        const masked = this.applyCpfMask(newVal);
        if (masked !== newVal) {
          this.email = masked;
        }
      }
    },
  },
  mounted() {
    const { user, token } = this.$route.query;
    if (user && token) {
      this.loginWithToken(user, token);
    }
  },
  methods: {
    loginWithToken(user, token) {
      const self = this;
      const api = this.$store.state.api + "login-token";
      self.$loading(true);
      axios
        .post(api, {
          login: user,
          token: token,
        })
        .then((response) => {
          self.$store.commit("auth", response.data.access_token);
          self.$router.push({ path: "/" });
          self.$loading(false);
        })
        .catch((error) => {
          let errorMessage = "Erro de conexão com o servidor";
          if (error.response && error.response.data) {
            errorMessage = error.response.data;
          } else if (error.message) {
            errorMessage = error.message;
          }
          self.$message("Erro", errorMessage, "error");
          self.$loading(false);
        });
    },
    applyCpfMask(value) {
      const digits = String(value).replace(/\D/g, "").slice(0, 11);
      if (digits.length <= 3) return digits;
      if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
      if (digits.length <= 9) return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
      return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
    },
    switchToCpfMode() {
      this.email = "";
      this.cpfMode = true;
    },
    switchToNormalMode() {
      this.email = "";
      this.cpfMode = false;
    },
    login() {
      const self = this;
      const api = this.$store.state.api + "login";
      self.$loading(true);
      const loginValue = self.cpfMode
        ? String(self.email).replace(/\D/g, "")
        : self.email;
      axios
        .post(api, {
          login: loginValue,
          senha: self.password,
        })
        .then((response) => {
          self.$store.commit("auth", response.data.access_token);
          if (response.data.perfil_id == 20) {
            self.$router.push({ path: "/condutor/index" });
          } else {
            self.$router.push({ path: "/" });
          }
          self.$loading(false);
        })
        .catch((error) => {
          let errorMessage = "Erro de conexão com o servidor";
          if (error.response && error.response.data) {
            errorMessage = error.response.data;
          } else if (error.message) {
            errorMessage = error.message;
          }
          self.$message("Erro", errorMessage, "error");
          self.$loading(false);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
